module.exports = __webpack_public_path__ + "nunito-sans-latin-900.412c6f01c1eb3a9135d53bc4fd220a35.woff";